import { OwnershipNouns } from '../ownershipNouns';

export const OwnershipEmptyState = ({ nouns }: { nouns: OwnershipNouns }) => (
  <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-border-secondary py-7xl px-2xl min-h-[280px]">
    <div className="flex flex-col items-center gap-xs text-center max-w-md">
      <h3 className="txt-small-bold text-text-primary">No {nouns.lowerPlural} recorded</h3>
      <p className="txt-extra-small-regular text-text-tertiary">
        Add significant {nouns.lowerPlural} individually. Remaining ownership is grouped automatically.
      </p>
    </div>
  </div>
);
